// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-data {
  cursor: pointer;
}

.noData {
  text-align: center;
}

.accordion {
  width: 97.2%;
  margin-left: 15px;
  margin-top: 24px;
}

@media only screen and (max-width: 600px) {
  .accordion {
    width: 92.15%;
    margin-left: 15px;
    margin-top: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/dashboardReport/chart/ReportChart.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;AAGJ;;AADA;EACI;IACI,aAAA;IACA,iBAAA;IACA,gBAAA;EAIN;AACF","sourcesContent":[".chart-data{\n    cursor: pointer;\n}\n.noData{\n    text-align: center;\n}\n.accordion{\n    width: 97.2%;\n    margin-left: 15px;\n    margin-top: 24px;\n}\n@media only screen and (max-width: 600px) {\n    .accordion {\n        width: 92.15%;\n        margin-left: 15px;\n        margin-top: 24px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
